import { DcBaseComponent } from '@deleteagency/dc';
import constants from './constants';

export default class SearchOrderComponent extends DcBaseComponent {
    static getNamespace() {
        return 'search-order';
    }

    onInit() {
        this.addListener(this.element, 'change', this._onChange);
    }

    _onChange = () => {
        const searchForm = document.getElementById(constants.SEARCH_FORM_ID);        
        const searchFormOrderInput = document.getElementById(constants.SEARCH_FORM_ORDER_INPUT_ID);        
        if (searchForm && searchFormOrderInput) {
            searchFormOrderInput.value = this.element.value;
            searchForm.submit();
        }
        
        const searchFormModal = document.getElementById(constants.SEARCH_FORM_MODAL_ID);
        const searchFormModalOrderInput = document.getElementById(constants.SEARCH_FORM_MODAL_ORDER_INPUT_ID);
        if (searchFormModal && searchFormModalOrderInput) {            
            searchFormModalOrderInput.value = this.element.value;
            searchFormModal.submit();
        }
    };
}
